import BeneficiariesAPI from './BeneficiariesAPI';
export default BeneficiariesAPI;
